import "styles/customer_info.css";

import { Stack, VStack } from "@chakra-ui/layout";
import { WaitTimesBanner } from "components/WaitTimes";

export const CustomerInfoBanner = () => {
    return (
        <VStack
            width="100%"
            bg="var(--dcs-dark-blue)"
            color="var(--dcs-black)"
            borderBottom="2px solid white"
        >
            <Stack direction="row">
                <WaitTimesBanner />
            </Stack>
        </VStack>
    );
};
